import { render, staticRenderFns } from "./sztd.vue?vue&type=template&id=49a5d5ad&scoped=true"
import script from "./sztd.vue?vue&type=script&lang=js"
export * from "./sztd.vue?vue&type=script&lang=js"
import style0 from "./sztd.vue?vue&type=style&index=0&id=49a5d5ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5d5ad",
  null
  
)

export default component.exports